import { render, staticRenderFns } from "./StockImageThumbnail.vue?vue&type=template&id=0c560540"
import script from "./StockImageThumbnail.vue?vue&type=script&lang=js"
export * from "./StockImageThumbnail.vue?vue&type=script&lang=js"
import style0 from "./StockImageThumbnail.vue?vue&type=style&index=0&id=0c560540&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports